import {ChangeDetectorRef, Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {Router} from '@angular/router';
import {ConfigService} from '../../services/config.service';
import {RestService} from '../../services/rest.service';

@Component({
    selector: 'app-navigator',
    templateUrl: './navigator.component.html',
    styleUrls: ['./navigator.component.scss']
})
export class NavigatorComponent implements OnInit, OnChanges {

    constructor(private router: Router, private cd: ChangeDetectorRef, private configService: ConfigService,
                private restService: RestService) {
    }

    @Input() items: any[];
    @Input() caseType: string;
    @Input() admin: boolean;
    public mainItems: any;
    public additionalItems: any;

    public selectedMenuItem = '';
    public selectedMenuItemMain = '';

    private config: any;
    public currentApp: any;
    public menuLevels: number;
    public isMinimalCase: boolean;

    ngOnInit() {
        this.currentApp = this.restService.getCurrentApp();
        this.parseItems();
        this.menuLevels = this.depthOf(this.items);
        this.isMinimalCase = this.getContextByUrl();
    }

    setRoute() {
        if (this.selectedMenuItem) {
            this.router.navigate([this.selectedMenuItem]);
        }
    }

    setSelected(index) {
        this.selectedMenuItemMain = index;
    }

    parseItems() {
        if (this.items.length > 2) {
            // const temp = this.items;
            this.mainItems = this.items;
            /*this.additionalItems = temp.slice(3);
            if (this.additionalItems && this.additionalItems.length > 0) {
                for (const item of this.additionalItems) {
                    if (window.location.href.indexOf(item.value) !== -1) {
                        this.selectedMenuItem = item.value;
                        break;
                    }
                }
            }*/
            if (this.mainItems && this.mainItems.length > 0) {
                for (const item of this.mainItems) {
                    if (window.location.href.indexOf(item.value) !== -1) {
                        this.selectedMenuItemMain = item.value;
                        break;
                    }
                }
            }
        } else {
            this.mainItems = this.items;
        }
        this.cd.markForCheck();
    }

    public getContextByUrl() {
        return this.router.url.indexOf('minimal-rental-price-case') !== -1;
    }

    public isParentOrChildRouteActive(subsetIndex) {

        const currentSubset = this.items.slice(subsetIndex, subsetIndex + 1);

        if (window.location.href.indexOf(currentSubset[0].value) !== -1) {
            return true; // ParentRoute is active
        } else if (currentSubset[0].children && currentSubset[0].children.length > 0) {
            for (const child of currentSubset[0].children) {
                if (window.location.href.indexOf(child.value) !== -1) {
                    this.setSelected(subsetIndex);
                    return true; // ChildRoute is active
                }
            }
        } else {
            return false;
        }
    }

    public depthOf(menu) {
        let level = 1;
        menu.forEach(el => {
            if (el.children && el.children.length > 0) {
                level = 2;
                // break;
            }
        });
        return level;
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.items && changes.items.currentValue) {
            this.parseItems();
            this.menuLevels = this.depthOf(this.items);
            this.isMinimalCase = this.getContextByUrl();
        }
    }
}
